import logJsUnexpected from '@zr/utilities/telemetry/logJsUnexpected';
import type { GTMPageEvent, GTMContactEvent, GTMJobEvent, GTMEventProperties } from './types';

/**
 * Initialize Google Tag Manager. GTM should not be initialized more than once on a page.
 * If no container ID was specified, an error will log and GTM will not initialize.
 *
 * @param cID - ID of the GTM container to report events to.
 */
export const initGoogleTagManager = (cID: string): void => {
  if (!cID) {
    logJsUnexpected('missing_gtm_container_id');
    return;
  }
  // Lots of directive-style comments here to prevent prettier from making
  // the snippet pretty + asking TypeScript to ignore this farglebargle.
  // prettier-ignore
  // eslint-disable-next-line
  // @ts-ignore
  // eslint-disable-next-line
  (function(w,d,s,l,i){var n=d.querySelector('[nonce]'); var nonceVal=n.nonce||n.getAttribute('nonce');w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),'nonce':nonceVal,event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;n&&j.setAttribute('nonce',nonceVal);f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer',cID);
};


/**
 * Generic method to fire a GTM event.
 *
 * @param event - Name of the event to be fired.
 * @param properties - Key value pairs of properties to be added to the event.
 */
export const fireGtmEvent = (event: string, properties: GTMEventProperties = {}): void => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event,
      ...properties,
    });
  }
};

/**
 * Fires off a GTM `page` event.
 *
 * @param pageEvent - Values required for the GTM 'page' event.
 */
export const firePageEvent = (pageEvent: GTMPageEvent): void => {
  fireGtmEvent('page', pageEvent);
};

/**
 * Fires off a GTM `contact` event.
 *
 * @param contactEvent - Values required for the GTM 'contact' event.
 */
export const fireContactEvent = (contactEvent: GTMContactEvent): void => {
  fireGtmEvent('contact', contactEvent);
};

/**
 * Fires off a GTM `job` event.
 *
 * @param jobEvent - Values required for the GTM 'job' event.
 */
export const fireJobEvent = (jobEvent: GTMJobEvent): void => {
  fireGtmEvent('job', jobEvent);
};

export const fireExperianPageViewEvent = (campaignEventAlreadyFired: boolean): void => {
  if (campaignEventAlreadyFired) {
    return;
  }

  fireGtmEvent('605-experian-js-pageview');
};
